import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  privateChip: {
    color: "#002685",
    "& svg": {
      color: "#002685",
    },
  },
  chip: {
    border: "none",
    borderRadius: 360,
    fontWeight: 400,
    paddingLeft: (props) => (props.isDesktop ? 0 : 10),
    backgroundColor: theme.palette.bkg.secondary,
  },
}));
